import { BatchStatus, MessageTransaction, WhatsAppTemplate } from "./types";
import Markdown from 'react-markdown'

export type TemplateParameter = {
  name: string;
  type: 'text' | 'number' | 'date' | 'image' | 'document';
  description: string;
  example?: string;
}

export type ComponentParameters = {
  header_parameters: Array<TemplateParameter>,
  body_parameters: Array<TemplateParameter>
}
export function extractTemplateParameters(template: WhatsAppTemplate): ComponentParameters {

  const parameters: ComponentParameters = { header_parameters: [], body_parameters: [] };

  if (template.parameter_format === 'NAMED') {
    template.components.forEach(component => {
      if (component.example) {
        if (component.example.header_text_named_params) {
          component.example.header_text_named_params.forEach(param => {
            parameters.header_parameters.push({
              name: param.param_name,
              type: 'text',
              description: `Header parameter: ${param.param_name}`,
              example: param.example
            });
          });
        }
        if (component.example.body_text_named_params) {

          component.example.body_text_named_params.forEach(param => {
            parameters.body_parameters.push({
              name: param.param_name,
              type: 'text',
              description: `Body parameter: ${param.param_name}`,
              example: param.example
            });
          });
        }
      }
    });
  } else if (template.parameter_format === 'POSITIONAL') {
    template.components.forEach(component => {
      if (component.example) {
        if (component.example.header_text) {
          component.example.header_text.forEach((example, index) => {
            parameters.header_parameters.push({
              name: `${index + 1}`,
              type: 'text',
              description: `Header parameter ${index + 1}`,
              example: example
            });
          });
        }
        if (component.example.body_text && component.example.body_text.length > 0) {
          component.example.body_text[0].forEach((example, index) => {
            parameters.body_parameters.push({
              name: `${index + 1}`,
              type: 'text',
              description: `Body parameter ${index + 1}`,
              example: example
            });
          });
        }
      }
    });
  }

  return parameters;
}

function getTemplateComponent(
  template: WhatsAppTemplate | null,
  type: "HEADER" | "BODY" | "FOOTER"
) {
  return template?.components?.find((c) => c.type === type);
}
function getTemplateHeader(template: WhatsAppTemplate | null) {
  return getTemplateComponent(template, "HEADER")?.text || "";
}
function getTemplateBody(template: WhatsAppTemplate | null) {
  return getTemplateComponent(template, "BODY")?.text || "";
}
function getTemplateFooter(template: WhatsAppTemplate | null) {
  return getTemplateComponent(template, "FOOTER")?.text || "";
}


export const fnRenderWhatsAppPreview = (selectedTemplate: WhatsAppTemplate | null, templateHeaderParameters: Record<string, any>, templateBodyParameters: Record<string, any>) => () => {
  if (!selectedTemplate) return null;
  let previewBody = getTemplateBody(selectedTemplate);
  let previewHeader = getTemplateHeader(selectedTemplate);
  Object.entries(templateHeaderParameters).forEach(([key, value]) => {
    const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
    previewHeader = previewHeader.replace(regex, value as string);
  });
  Object.entries(templateBodyParameters).forEach(([key, value]) => {
    const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
    previewBody = previewBody.replace(regex, value as string);
  });
  return (
    <div className="bg-green-50 rounded-lg p-4 mb-2">
      <div className="font-bold text-green-700 mb-1">
        WhatsApp Preview
      </div>
      {getTemplateHeader(selectedTemplate) && (
        <div className="text-base font-medium mb-2">{previewHeader}</div>
      )}
      <div className="whitespace-pre-wrap text-neutral-800">
        <Markdown>{previewBody}</Markdown>
      </div>
      {getTemplateFooter(selectedTemplate) && (
        <div className="text-xs text-neutral-500 mt-2 ">
          {getTemplateFooter(selectedTemplate)}
        </div>
      )}
    </div>
  );
};


export const fnRenderSmsPreview = (selectedTemplate: WhatsAppTemplate | null, templateParameters: Record<string, any>, customText?: string) => () => {

  let previewBody = getTemplateBody(selectedTemplate);
  if (customText && customText != "") {
    previewBody = customText
  } else {
    Object.entries(templateParameters).forEach(([key, value]) => {
      const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
      previewBody = previewBody.replace(regex, value as string);
    });
  }
  return (
    <div className="bg-blue-50 rounded-lg p-4 mb-2">
      <div className="font-bold text-blue-700 mb-1">
        SMS Preview
      </div>
      <div className="whitespace-pre-wrap text-neutral-800">
        <Markdown>{previewBody}</Markdown>
      </div>
    </div>
  );
};



export const fnRenderTemplateFields = (selectedTemplate: WhatsAppTemplate | null,
  templateHeaderParameters: Record<string, any>, templateBodyParameters: Record<string, any>, handleHeaderParameterChange: (name: string, value: any) => void, handleBodyParameterChange: (name: string, value: any) => void) => () => {

    if (!selectedTemplate) return null;

    const templateParams = extractTemplateParameters(selectedTemplate)

    return (
      <div className="space-y-4">
        {/* <h3 className="text-lg font-medium text-neutral-800 dark:text-white">
          Template: {selectedTemplate.name} ({selectedTemplate.parameter_format})
        </h3> */}
        {/* <div className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">
          Status: {selectedTemplate.status} | Language: {selectedTemplate.language} | Category: {selectedTemplate.category}
        </div> */}

        {templateParams.header_parameters.length > 0 ? (
          <div className="space-y-4">
            {templateParams.header_parameters.map((field: any) => (
              <div key={field.name} className="space-y-1">
                <label htmlFor={field.name} className="block text-sm font-medium text-neutral-700">
                  Header Parameter &#123;&#123;{field.name}&#125;&#125;
                </label>
                {/* {field.example && (
                  <div className="text-xs text-neutral-500 dark:text-neutral-400 mb-1">
                    Example: {field.example}
                  </div>
                )} */}

                <input
                  type="text"
                  id={field.name}
                  value={templateHeaderParameters[field.name] || ''}
                  onChange={(e) => handleHeaderParameterChange(field.name, e.target.value)}
                  placeholder={field.example ? `e.g. ${field.example}` : ''}
                  className="w-full rounded-lg border px-4 py-2 focus:ring-2 focus:ring-neutral-800 focus:outline-none text-neutral-900 bg-white"
                />

              </div>
            ))}

          </div>

        ) : (
          <div className="text-sm text-neutral-500">
            This template has no header parameters to fill.
          </div>
        )}
        {templateParams.body_parameters.length > 0 ? (
          <div className="space-y-4">
            {templateParams.body_parameters.map((field: any) => (
              <div key={field.name} className="space-y-1">
                <label htmlFor={field.name} className="block text-sm font-medium text-neutral-700">
                  Body Parameter &#123;&#123;{field.name}&#125;&#125;
                </label>
                {/* {field.example && (
                  <div className="text-xs text-neutral-500 dark:text-neutral-400 mb-1">
                    Example: {field.example}
                  </div>
                )} */}

                <input
                  type="text"
                  id={field.name}
                  value={templateBodyParameters[field.name] || ''}
                  onChange={(e) => handleBodyParameterChange(field.name, e.target.value)}
                  placeholder={field.example ? `e.g. ${field.example}` : ''}
                  className="w-full rounded-lg border px-4 py-2 focus:ring-2 focus:ring-neutral-800 focus:outline-none text-neutral-900 bg-white"
                />

              </div>
            ))}

          </div>

        ) : (
          <div className="text-sm text-neutral-500">
            This template has no body parameters to fill.
          </div>
        )}
      </div>
    );
  };



export const getStatusColor = (status: MessageTransaction['status']) => {
  switch (status) {
    case BatchStatus.delivered:
    case BatchStatus.completed:
    case BatchStatus.sent:
      return 'text-green-600';
    case BatchStatus.failed:
      return 'text-red-600';
    case BatchStatus.progress:
      return 'text-blue-600';
    default:
      return 'text-neutral-600';
  }
};

export const getStatusText = (status: MessageTransaction['status']) => {
  switch (status) {
    case BatchStatus.delivered:
      return 'Delivered';
    case BatchStatus.failed:
      return 'Failed';
    case BatchStatus.sent:
      return 'Sent';
    case BatchStatus.progress:
      return 'In Progress';
    case BatchStatus.completed:
      return 'Completed';
    default:
      return 'Unknown';
  }
}